import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { MAIN_THEME } from '@styles';
import { valueCommaSeparated } from '@utils/formatting-utils';

interface IOfferCoverageProps {
  disabled: boolean;
  premium: number;
  currency: string;
  premiumTitle: string;
  coverageTitle: string;
  coverage: number;
  hidePremium: boolean;
}

const useStyles = makeStyles()(() => ({
  container: {
    width: '100%',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'flex-start',
  },
  title: {
    color: MAIN_THEME.color.black,
    fontSize: MAIN_THEME.fontSize.sm,
    lineHeight: '17px',
    display: 'block',
    textAlign: 'left',
  },
  mainAmount: {
    color: MAIN_THEME.color.black,
    fontSize: MAIN_THEME.fontSize.lg,
    lineHeight: '25px',
    textAlign: 'left',
    fontWeight: 'bold',
    margin: '3px 0',
  },
  secondaryAmount: {
    color: MAIN_THEME.color.black,
    fontSize: MAIN_THEME.fontSize.lg,
    lineHeight: '25px',
    textAlign: 'left',
    fontWeight: 'bold',
    margin: '3px 0',
  },
  detailContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignContent: 'center',
    flexWrap: 'wrap',
    paddingTop: '10px',
  },
  coverages: {},
  numberValue: {
    fontSize: MAIN_THEME.fontSize.lg,
  },
  textValue: {
    fontSize: MAIN_THEME.fontSize.xs,
  },
  mainAmountValue: {
    color: MAIN_THEME.color.black,
    fontSize: MAIN_THEME.fontSize.lg,
    lineHeight: '20px',
    float: 'left',
    fontWeight: 'bold',
    // height: '100px',
  },
  premiumAmount: {
    color: MAIN_THEME.color.red,
    fontSize: MAIN_THEME.fontSize.lg,
    lineHeight: '20px',
    fontWeight: 'bold',
    float: 'right',
  },
}));

const OfferCoverage: React.FC<IOfferCoverageProps> = ({
  premiumTitle,
  coverageTitle,
  currency,
  coverage,
  premium,
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <div
        className={classes.titleContainer}
        style={{
          justifyContent: premiumTitle ? 'space-between' : 'flex-start',
        }}
      >
        <span className={classes.title}>{coverageTitle}</span>
        {!!premiumTitle && (
          <span className={classes.title}>{premiumTitle}</span>
        )}
      </div>
      <div className={classes.detailContainer}>
        <span className={classes.mainAmountValue}>
          {`${currency} ${valueCommaSeparated(coverage?.toFixed(0))}`}
        </span>
        <span className={classes.premiumAmount}>
          {`${currency} ${valueCommaSeparated(premium?.toFixed(0))}`}
        </span>

        {/* {renderValues()}



        
        <CustomDropdown
          disabled={hidePremiumBreakdown || disabled}
          options={options}
          value={getDropdownText()}
          classes={{
            container: offerClasses?.dropdownClasses?.container,
            button: offerClasses?.dropdownClasses?.button,
            arrow: offerClasses?.dropdownClasses?.arrow,
          }}
          onOptionClick={(option: string) =>
            onCycleChange(option as CompanyOfferWidgetPremiums)
          }
        /> */}
      </div>
    </div>
  );
};

export default OfferCoverage;
